import React, { InputHTMLAttributes, useCallback } from 'react';
import { useField } from 'formik';
import { useErrorText } from '../hooks/useErrorText';
import { SelectValue } from '../selectTW/interfaces';
import { SimpleToggleTW } from './SimpleToggleTW';

type ToggleTWProps = Omit<InputHTMLAttributes<HTMLButtonElement>, 'onChange'> & {
  name: string;
  className?: string;
  text?: string;
  onChange?: (value: boolean) => void;
};

export const ToggleTW: React.FC<ToggleTWProps> = ({ name, text, className, ...rest }) => {
  const [{ value, onChange, ...fieldInputProps }, fieldMetaProps] = useField<boolean>(name);
  const errorText = useErrorText<SelectValue>(fieldMetaProps);
  const labelClassName = errorText ? 'text-text-error' : 'text-text-default-content';

  const handleOnChange = useCallback(
    (value: boolean) => {
      onChange({
        target: {
          name,
          value,
        },
      });
      rest.onChange?.(value);
    },
    [name, onChange, rest]
  );

  return (
    <SimpleToggleTW
      {...rest}
      {...fieldInputProps}
      className={className}
      text={text}
      checked={value}
      onChange={handleOnChange}
      labelClassName={labelClassName}
    />
  );
};
